export type SortOrder = "asc" | "desc";

export function cycleSortField<T extends string>(
  current: T | undefined,
  field: T,
  order: SortOrder,
): { sortBy: T | undefined; sortOrder: SortOrder } {
  if (current === field) {
    if (order === "asc") {
      return { sortBy: field, sortOrder: "desc" };
    }
    return { sortBy: undefined, sortOrder: "asc" };
  }
  return { sortBy: field, sortOrder: "asc" };
}

export function compareStrings(
  a: string | null | undefined,
  b: string | null | undefined,
  order: SortOrder,
): number {
  const av = a ?? "";
  const bv = b ?? "";
  const cmp = av.localeCompare(bv);
  return order === "asc" ? cmp : -cmp;
}

export function compareNumbers(
  a: number | null | undefined,
  b: number | null | undefined,
  order: SortOrder,
): number {
  const av = a ?? Number.NEGATIVE_INFINITY;
  const bv = b ?? Number.NEGATIVE_INFINITY;
  const cmp = av === bv ? 0 : av < bv ? -1 : 1;
  return order === "asc" ? cmp : -cmp;
}

export function compareDates(
  a: string | null | undefined,
  b: string | null | undefined,
  order: SortOrder,
): number {
  const av = a ? new Date(a).getTime() : Number.NEGATIVE_INFINITY;
  const bv = b ? new Date(b).getTime() : Number.NEGATIVE_INFINITY;
  const cmp = av === bv ? 0 : av < bv ? -1 : 1;
  return order === "asc" ? cmp : -cmp;
}

export function durationMs(
  startedAt: string,
  finishedAt: string | null,
): number {
  if (!finishedAt) return Number.NEGATIVE_INFINITY;
  const ms = new Date(finishedAt).getTime() - new Date(startedAt).getTime();
  return Number.isNaN(ms) ? Number.NEGATIVE_INFINITY : ms;
}
